/**
 * @deprecated This should not be called if using Auth0.
 */
export default function useUserContext() {
    throw new Error('This should not be called if using Auth0.');
}
